import React from 'react';

// utils
import { func, shape } from 'prop-types';

// components
import { Box, Typography } from '@mui/material';
import { MDialog } from 'common';

const dialogBodyStyles = {
  minHeight: 266,
};

const AuthSeqConfirmationDialog = ({ onConfirm, onClose, location, product }) => {
  return (
    <MDialog
      header="Save Authorization Sequence?"
      leftButtonAction={() => onClose(false)}
      leftButtonText="Back"
      onClose={() => onClose(false)}
      open
      rightButtonAction={onConfirm}
      rightButtonText="Confirm"
      slotProps={{ paper: { sx: dialogBodyStyles } }}
    >
      <Box>
        <Typography variant="body2">
          {`Please confirm you would like to save your changes to the Authorization Sequencing for
          ${product.nameShort} at ${location.nameShort}. Sequence changes will take affect immediately.`}
        </Typography>
      </Box>
    </MDialog>
  );
};

AuthSeqConfirmationDialog.propTypes = {
  location: shape({}).isRequired,
  onClose: func.isRequired,
  onConfirm: func.isRequired,
  product: shape({}).isRequired,
};

export default AuthSeqConfirmationDialog;
